import React, { useEffect, useState } from "react";
import PopupPortal from "../../../shared/common/PopupWindow";
import { getAuthToken, getAuthHeader, Logout } from "../../../Auth/Utils";
import { getNotificationEndpoint } from "../Config";

const InitialNotificationPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [notificationText, setNotificationNotificationText] = useState('');

  const getInitialNotification = async () => {
    if (!getAuthToken) {
      return false;
    }
    const response = await fetch(getNotificationEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthHeader()
      },
    });
    if (response.ok) {
      let json = await response.json();
      if (!json.error && "message_thai" in json && json.message_thai) {
        setIsOpen(true);
        setNotificationNotificationText(json.message_thai);
        if (json.error_type === 'session_expired') {
          Logout();
        }
      }
    } else {
      console.log("Initial comment Error HTTP: " + response.status);
      let json = await response.json();
      if (json.code === 'jwt_auth_invalid_token') {
        Logout();
      }
    }
  }

  const closePopup = () => {
    setIsOpen(false);
  }

  useEffect(() => {
    let mounted = true;
    getInitialNotification().then(() => {
      if(mounted) {
        console.log('Initial Withdraw notification checked');
      }
    })
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <PopupPortal open={isOpen} onClose={() => closePopup()}>
      <div className="notification-wrapper">
        <div className={"notification"} dangerouslySetInnerHTML={{ __html: notificationText }}/>
        <button className="button-white"
                onClick={() => closePopup()}>Ok</button>
      </div>
    </PopupPortal>
  );
}

export default InitialNotificationPopup;
